import {Product} from "@app/core/product/domain/dtos/product";

export interface ListDetailParams {
    products: Product[],
    name: string;
    finalPrice: number;
    taxes: number;
    items: number;
    totalPallets: number;
    totalPrice: number;
    couponImport: number;
}

export class ListDetail {
    readonly products: Product[];
    readonly name: string;
    readonly finalPrice: number;
    readonly taxes: number;
    readonly items: number;
    readonly totalPallets: number;
    readonly totalPrice: number;
    readonly isFavoriteList: boolean;
    readonly couponImport: number;

    constructor(params: ListDetailParams) {
        this.products = params.products;
        this.name = params.name;
        this.finalPrice = params.finalPrice;
        this.taxes = params.taxes;
        this.items = params.items;
        this.totalPallets = params.totalPallets;
        this.totalPrice = params.totalPrice;
        // This is the only way to identify if a list detail is a favorite list.
        this.isFavoriteList = params.name.trim() === "FAVLIST";
        this.couponImport = params.couponImport;
    }
}
